module.exports = __webpack_public_path__ + "static/media/Loft.a64571dc.jpg";